export enum CardType {
  REGULAR = '',
  FILTERS = 'filters-card',
  NONE = 'none',
  TRANSPARENT = 'transparent',
}

export enum CardTheme {
  PRIMARY = 'card-primary',
  WHITE = 'card-white',
  LIGHT = 'card-light',
}

export enum BorderTheme {
  BASIC = 'border-neutral-300',
  WARNING = 'border-yellow',
}

export interface CardProps {
  icon?: string;
  header?: React.ReactNode;
  info?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  cardType?: CardType;
  mandatory?: boolean;
  id?: string;
  cardTheme?: CardTheme;
  dataTestId?: string;
  borderTheme?: BorderTheme;
}

export const CardThemeStyles = {
  [CardTheme.PRIMARY]: {
    cardHeader: 'bg-primary-600-opacity-10 text-primary-600',
    card: 'bg-primary-600-opacity-10 text-primary-600',
    cardIcon: '[&_path]:fill-primary-600',
    cardInfo: '',
  },
  [CardTheme.WHITE]: {
    cardHeader: 'bg-neutral-50 text-primary-600',
    card: 'bg-neutral-50 text-primary-600',
    cardIcon: '[&_path]:fill-primary-600',
    cardInfo: '',
  },
  [CardTheme.LIGHT]: {
    cardHeader: 'text-neutral-950',
    card: 'bg-neutral-100 text-neutral-950',
    cardIcon: '[&_path]:fill-neutral-950-opacity-60',
    cardInfo: 'text-neutral-600',
  },
};

export const CardTypeStyles = {
  [CardType.REGULAR]: {
    card: '',
    cardHeader: '',
    cardBody: 'p-[15px]',
  },
  [CardType.FILTERS]: {
    card: '',
    cardHeader: '',
    cardBody: 'p-[calc(var(--spacing-md)-2px)_var(--spacing-md)]',
  },
  [CardType.NONE]: {
    card: 'border-none',
    cardHeader: '',
    cardBody: 'p-0',
  },
  [CardType.TRANSPARENT]: {
    card: 'border-none bg-transparent mb-0',
    cardHeader: '',
    cardBody: 'py-[15px] px-0',
  },
};

export const BorderThemeStyles = {
  [BorderTheme.BASIC]: {
    card: 'border-neutral-300',
  },
  [BorderTheme.WARNING]: {
    card: 'border-yellow',
  },
};

export const TransparentCardTextStyles = {
  [CardTheme.PRIMARY]: 'text-primary-600',
  [CardTheme.WHITE]: 'text-primary-600',
  [CardTheme.LIGHT]: 'text-neutral-950',
};
